import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type PropType, computed } from 'vue';

import LocalTime from '@exchange/libs/components/history/LocalTime.vue';
import usePromise from '@exchange/libs/composables/shared/src/lib/usePromise';
import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


const __default__ = {
  name: 'TermsAndConditionsModal',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  accept: { type: Function as PropType<() => Promise<void>>, required: true },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
  effectiveDate: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const { loading: accepting, createPromise: acceptNow } = usePromise(props.accept);

const effectiveDate = computed(() => new Date(props.effectiveDate));

return (_ctx: any,_cache: any) => {
  const _component_x_link_external = _resolveComponent("x-link-external")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "terms-and-conditions-modal",
    "can-close": false,
    wide: true,
    variant: __props.variant,
    title: _ctx.$t('ui.termsAndConditions.title')
  }, {
    content: _withCtx(() => [
      _createVNode(_component_i18n_t, {
        class: "terms-and-conditions-modal__content",
        tag: "p",
        keypath: "ui.termsAndConditions.disclaimer"
      }, {
        linkTermsAndConditions: _withCtx(() => [
          _createVNode(_component_x_link_external, {
            href: _ctx.$t('ui.termsAndConditions.disclaimerLinks.linkTermsAndConditions.link'),
            "use-system-browser": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('ui.termsAndConditions.disclaimerLinks.linkTermsAndConditions.text')), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ]),
        termsEffectiveDate: _withCtx(() => [
          _createVNode(LocalTime, {
            time: effectiveDate.value,
            format: "d MMMM yyyy"
          }, null, 8, ["time"])
        ]),
        linkCustomerCare: _withCtx(() => [
          _createVNode(_component_x_link_external, {
            href: _ctx.$t('ui.termsAndConditions.disclaimerLinks.linkSupport.link'),
            "use-system-browser": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('ui.termsAndConditions.disclaimerLinks.linkSupport.text')), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ]),
        _: 1
      })
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_x_button, {
        variant: "primary",
        loading: _unref(accepting),
        disabled: _unref(accepting),
        onClick: _unref(acceptNow)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('fundamentals.ok')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["variant", "title"]))
}
}

})